<section class="pageBanner w-full max-w-[1920px] mx-auto relative min-h-[179px] md:h-[552px] xxl:h-[652px]">
    <div class="pageBanner__items">
        @for (item of bannerContent; track $index; let idx = $index) {
        <picture>
            <source media="(max-width: 430px)" [srcset]="assetsCDNUrl + item.image_mob_url" />
            <source media="(min-width: 431px)" [srcset]="assetsCDNUrl + item.image_url" />
            <img class="pageBanner__image w-full min-h-[179px] md:h-[552px] xxl:h-[652px] object-cover object-top mx-auto"
                [ngSrc]="assetsCDNUrl + item.image_mob_url" [alt]="item.alt_text" width="700" height="350" priority
                fetchpriority="high" />
        </picture>
        <div class="container">
            <div
                class="pageBanner__content pt-4 pb-11 md:p-0 md:absolute top-[70px] xl:top-[100px] left-0 right-0 z-10">
                <h1 class="heading-primary-8xl md:!text-center mb-3 md:!text-white" [ngClass]="item.class_name"
                    [innerHTML]="item.title"></h1>
                <div class="md:text-center editor-content md:!text-white" [ngClass]="item.class_name"
                    [innerHTML]="item.sub_title">
                </div>
            </div>
        </div>
        }
    </div>
</section>